import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  margin-bottom: var(--space-600);
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-400);

  ${mediaQueries.tablet} {
    margin-bottom: var(--space-500);
    flex-direction: row;
    justify-content: space-between;
  }
`

export const Content = styled.div`
  display: flex;
  gap: var(--space-400);
  flex-direction: column;

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
  }
`

export const Actions = styled.div`
  display: flex;
  gap: var(--space-400);
  flex-direction: row;
  flex-flow: wrap;
  align-self: flex-end;

  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: center;
  }
`
